import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useStyles from './styles';
export default function ErrorPage() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.errorPage
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.gradient
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.errorContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.errorNum
  }, "404"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h1"
  }, "Not Found"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light"
  }, "The resource requested could not be found on this server!"), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    variant: "priority",
    to: "/active_dashboard",
    'custom-attribute': '26-error-page'
  }, "Back home"))));
}